import React from 'react';
import PropTypes from 'prop-types';

import classes from './Input.module.css';

export const FirstName = (props) => {
    const { changed, blurred, clicked, firstNameState, disable } = props;
    const data = {
        config: {
            id: "firstName",
            type: 'text',
            label: 'First Name'
        },
        change: e => changed(e, 'firstName'),
        blur: () => blurred('firstName'),
        click: (event) => clicked(event)
    };

    let inputElement = null;
    const inputClasses = [classes.InputElement];
    const errorId = `${data.config.id}_error`;

    if (!firstNameState.valid && firstNameState.touched) {
        inputClasses.push(classes.Invalid);
    }
    
    inputElement = <input
        id={data.config.id}
        type={data.config.type}
        className={`analytics-form-fields ${inputClasses.join(' ')}`}
        value={firstNameState.value}
        onChange={data.change}
        onBlur={data.blur} 
        onClick={clicked ? data.click: ""}
        aria-describedby={errorId}
        aria-invalid={!!firstNameState.errMsg}
        aria-required="true" 
        readOnly={disable} />;

    return (
        <div className={classes.Input}>
            <label className={classes.Label} htmlFor={data.config.id}>{data.config.label}</label>
            {inputElement}
            {firstNameState.errMsg ? <p className={classes.errMsg} aria-live="polite" id={errorId} aria-atomic="true" >{firstNameState.errMsg}</p> : null}
        </div>
    );

};

FirstName.propTypes = {
    firstNameState: PropTypes.shape({
        value: PropTypes.string,
        errMsg: PropTypes.string,
        valid: PropTypes.bool,
        touched: PropTypes.bool,
        rules: PropTypes.shape({
            maxLength: PropTypes.number,
            pattern: PropTypes.instanceOf(RegExp),
            patternMessage: PropTypes.string,
            required: PropTypes.bool
        })
    }),
    disable: PropTypes.bool,
    changed: PropTypes.func,
    blurred: PropTypes.func
};

FirstName.defaultProps = {
    firstNameState: {
        value: '',
        errMsg: null,
        valid: true,
        touched: false,
        rules: {
            maxLength: 30,
            pattern: '^[a-zA-Z]*$',
            patternMessage: 'Should contain only Alphabets',
            required: true
        }
    },
    disable: false,
    changed: () => { },
    blurred: () => { }
};

export default FirstName;